import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { AppConfig } from "../../../AppConfig";
import {
  BASIC_DARK_GRAY,
  BASIC_LINE,
  BASIC_ORANGE,
} from "../../../constants/colors";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { Input } from "../../atoms/Input";

export const MemoInput: React.FC = () => {
  const [memo, setMemo] = useState("");

  useEffect(() => {
    const storedMemo = LocalStorageManager.Instance.getObject<string>(
      AppConfig.Instance.LocalStorageKey["userMemo"],
    );

    if (storedMemo) setMemo(storedMemo);
  }, []);

  const handleMemoChange = useCallback((value: string) => {
    setMemo(value);
    LocalStorageManager.Instance.saveObject(
      AppConfig.Instance.LocalStorageKey["userMemo"],
      value,
    );
  }, []);

  return (
    <MemoInputContainer>
      <MemoInputTitle>
        アレルギーをお持ちの方や苦手なものがある方は、
        <span> 対象メニューも併せてご記入下さい。</span>
      </MemoInputTitle>

      <InputContainer id={`input-container`}>
        <Input
          id={`memo-input`}
          name="memo"
          placeholder="記入例：ペッパーハンバーグのペッパー抜き"
          value={memo}
          onChange={handleMemoChange}
        />
      </InputContainer>
    </MemoInputContainer>
  );
};

const MemoInputContainer = styled.div`
  margin: 40px 0;
  text-align: left;
  margin: 0 16px 36px;
  color: ${BASIC_DARK_GRAY};
`;

const MemoInputTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 28px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${BASIC_LINE};
  span {
    text-decoration: underline;
    color: ${BASIC_ORANGE};
  }
`;

const InputContainer = styled.div`
  input {
    line-height: 1.9em;
    font-size: 16px;
    font-weight: 400;
  }
`;
